import { dayts } from './dayts';
export var getWeekends = function (date) {
    var weekendDates = [];
    var dayInstance = dayts(date);
    if (dayInstance.isValid()) {
        var numDays = dayInstance.daysInMonth();
        var lastDay = dayInstance.date(numDays);
        var currentDay = dayInstance.startOf('M');
        while (!currentDay.isAfter(lastDay)) {
            if (currentDay.day() === 0 || currentDay.day() === 6) {
                weekendDates.push(currentDay);
            }
            currentDay = currentDay.add(1, 'day');
        }
    }
    return weekendDates;
};
//# sourceMappingURL=get-month-weekend.js.map